module.exports = __webpack_public_path__ + "static/xbike-674ab86e780045af5983dc1fb3c2b84a.jpg";